import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import CircularProgress from '@mui/joy/CircularProgress';
import { Box } from '@mui/joy';



export default function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVER_HOST}/me`, {
      credentials: 'include', 
    })
      .then(res => {
        if (res.ok) {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      })
      .catch(() => setAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <Box sx={{display : "flex", height : "100vh", justifyContent : "center", alignItems : "center"}}><CircularProgress variant="soft" /></Box>
  }

  return authenticated ? children : <Navigate to="/" />;
}
